import React from 'react';
import { Box, FormPreloader, FormTitle } from '@common-fe/common-fe';

import FieldLevelAccess from '../../FieldLevelAccess';

interface Props {
  isLoading?: boolean;
  id?: string;
  isEditMode?: boolean;
}

const FieldLevelAccessSection: React.FC<Props> = ({ isLoading = false,isEditMode = false, id }) => {
  return (
    <Box
      round="container1Round"
      background="canvas"
      pad="l"
      data-testid="field-level-access"
      margin={{ top: 'l' }}
      border={{ size: 'small', color: 'border1' }}
    >
      <FormTitle>Field Level Access</FormTitle>
      {isLoading ? <FormPreloader count={2} /> : (
        <Box direction='column'>
          <FieldLevelAccess isEditMode={isEditMode} id={id} />
        </Box>
      ) }
    </Box>
  );
};

export default FieldLevelAccessSection;
